  //-----------------------
  // React basic Components
  //-----------------------
  import React                                               from "react";
  import PropTypes                                           from "prop-types";
  import { NavLink }                                         from "react-router-dom";
  import { connect }                                         from "react-redux";
  //-----------------------------
  // @material-ui/core components
  //-----------------------------
  import withStyles                                          from "@material-ui/core/styles/withStyles";
  import Button                                              from '@material-ui/core/Button';
  import TextField                                           from '@material-ui/core/TextField';
  import CircularProgress                                    from "@material-ui/core/CircularProgress";
//import AccountCircleIcon                                   from "@material-ui/icons/AccountCircle";
  import Dialog                                              from '@material-ui/core/Dialog';
  import DialogActions                                       from '@material-ui/core/DialogActions';
  import DialogContent                                       from '@material-ui/core/DialogContent';
  import DialogContentText                                   from '@material-ui/core/DialogContentText';
  import DialogTitle                                         from '@material-ui/core/DialogTitle';
  import Slide                                               from '@material-ui/core/Slide';
  //[SNACKBAR]
  import Snackbar                                            from '@material-ui/core/Snackbar';
  import MuiAlert                                            from '@material-ui/lab/Alert';
  //[PASSWORDTYPE]
  import InputAdornment                                      from '@material-ui/core/InputAdornment';
  import IconButton                                          from '@material-ui/core/IconButton';
  import Visibility                                          from '@material-ui/icons/Visibility';
  import VisibilityOff                                       from '@material-ui/icons/VisibilityOff';
  //------------------
  // Custom components
  //------------------
  import GridContainer                                       from "components/Grid/GridContainer.jsx";
  import GridItem                                            from "components/Grid/GridItem.jsx";
  import CustomButton                                        from "components/CustomButtons/Button.jsx";
//import CustomInput                                         from "components/CustomInput/CustomInput.jsx";
//import CustomDropdown                                      from "components/CustomDropdown/CustomDropdown.jsx";
  //----------
  // Libraries
  //----------
  import Cookies                                             from 'js-cookie';
//import ReCAPTCHA                                           from "react-google-invisible-recaptcha";
  //------------
  // WebServices
  //------------
  import { history }                                         from "../../_helpers";
  import { api }                                             from "../../_constants";
  import { wu_StaticDataService }                            from "../../_services";
  import { wu_Utilities }                                    from "../../_services";
  import { wu_LoginLogoutService }                           from "../../_services";
  import { wu_ProfileService }                               from "../../_services";
  import { wu_RegisterLightService }                         from "../../_services";
  import { wu_AppVersion }                                   from "../../_services";
//import { wu_TransactionFlow }                              from "../../_services";
//import { wu_OnlineMTService }                              from "../../_services";
  //------
  // Style
  //------
  import RegisterLight1LoginStyle                                      from "./RegisterLight1LoginStyle.jsx";
  //-------
  // images
  //-------
  import logo                                                from "assets/img/wu/WU_CONTENT_main_symbol_left.svg";
//import WU_STEPS_estimate_active                            from "assets/img/wu/WU_STEPS_estimate_active.svg";
//import WU_STEPS_estimate_inactive                          from "assets/img/wu/WU_STEPS_estimate_inactive.svg";
//import WU_STEPS_progress_symbol_active                     from "assets/img/wu/WU_STEPS_progress_symbol_active.svg";
//import WU_STEPS_progress_symbol_inactive                   from "assets/img/wu/WU_STEPS_progress_symbol_inactive.svg";
//import WU_STEPS_recipient_active                           from "assets/img/wu/WU_STEPS_recipient_active.svg";
//import WU_STEPS_recipient_inactive                         from "assets/img/wu/WU_STEPS_recipient_inactive.svg";
//import WU_STEPS_review_active                              from "assets/img/wu/WU_STEPS_review_active.svg";
//import WU_STEPS_review_inactive                            from "assets/img/wu/WU_STEPS_review_inactive.svg";
//import WU_STEPS_sender_active                              from "assets/img/wu/WU_STEPS_sender_active.svg";
//import WU_STEPS_sender_inactive                            from "assets/img/wu/WU_STEPS_sender_inactive.svg";
  //----------
  // variables
  //----------
  const filename = "RegisterLight1Login ";
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  //[SNACKBAR]
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  //[Lockers]
  var RegisterLight1Login_continue_locked = true;

class RegisterLight1Login extends React.Component {
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Basic Methods-------------------------------------
  //----------------------------------------------------------------------------------------------------
  constructor(props) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName+JSON.stringify(props));}

    let loginEmail = localStorage.getItem("HTTP_user");

    super(props);
    this.state = {
      dialog_msg                                           : "",
      dialog_isOpen                                        : false,

      viewPleaseWait_hidden                                : true,

      //[SNACKBAR]
      Snackbar_textField_open                              : false,
      Snackbar_textField_msg                               : "",

      //[HONEYMOON]
      textField0                                           : "", //4279034659
      textField0_hasError                                  : false,

      loginEmail                                           : loginEmail,
      loginEmail_hasError                                  : false,
      loginEmail_disabled                                  : false,//loginEmail === "" ? false : true,
      loginPassword                                        : "",
      loginPassword_hasError                               : false,
      loginPassword_disabled                               : false,

      dialog2_msg                                          : "",
      dialog2_isOpen                                       : false,

      dialog3_msg                                          : "",
      dialog3_isOpen                                       : false,

      passwordType1                                        : "password",
    };
    //------------
    //translations
    //------------
    this.texts_gr = wu_StaticDataService.wu_getLocales_gr({});
    this.texts_en = wu_StaticDataService.wu_getLocales_en({});
    //--------
    //bindings
    //--------
    this.verifyGenericItem                                            = this.verifyGenericItem.bind(this);
    this.dialog_handleClose                                           = this.dialog_handleClose.bind(this);
    this.startSpinners                                                = this.startSpinners.bind(this);
    this.stopSpinners                                                 = this.stopSpinners.bind(this);

    //[Lockers]
    this.isLockersActive                                              = this.isLockersActive.bind(this);
    this.startLockers                                                 = this.startLockers.bind(this);
    this.stopLockers                                                  = this.stopLockers.bind(this);

    this.handleSubmit                                                 = this.handleSubmit.bind(this);
    this.handleSubmit_isDisabled                                      = this.handleSubmit_isDisabled.bind(this);

    this.handleSubmit_with_enter                                      = this.handleSubmit_with_enter.bind(this);
    this.handleSubmit_with_recaptcha                                  = this.handleSubmit_with_recaptcha.bind(this);
    this.recaptchaRef                                                 = React.createRef();

    this.dialog2_handleClose                                          = this.dialog2_handleClose.bind(this);
    this.dialog2_handleResendEmail                                    = this.dialog2_handleResendEmail.bind(this);

    this.dialog3_handleClose                                          = this.dialog3_handleClose.bind(this);
    this.dialog3_gotoProfile                                          = this.dialog3_gotoProfile.bind(this);

    this.get_PasswordType1                                           = this.get_PasswordType1.bind(this);
    this.handlePopoverOpen_passwordType1                             = this.handlePopoverOpen_passwordType1.bind(this);

    //[SNACKBAR]
    this.Snackbar_textField_handleOpen                                = this.Snackbar_textField_handleOpen.bind(this);
    this.Snackbar_textField_handleClose                               = this.Snackbar_textField_handleClose.bind(this);
  }
  //----------------------------------------------------------------------------------------------------
  componentWillMount() {
    let methName = filename+"componentWillMount ";
    if(api.print_logs){console.log(methName);}

    localStorage.setItem("prev_view", localStorage.getItem("curr_view"));
    localStorage.setItem("curr_view", filename);

    //--------------------
    //global variables set
    //--------------------
    try { localStorage.setItem("RegisterLight1".trim(), "");  } catch(err){;}
    localStorage.setItem("FLOW_confirm_register_after", api.FLOW_confirm_register_after_login_transfer);

    //[Lockers]
    this.stopLockers();
  }
  //----------------------------------------------------------------------------------------------------
  componentDidMount() {
    let methName = filename+"componentDidMount ";
    if(api.print_logs){console.log(methName);}
  }
  //----------------------------------------------------------------------------------------------------
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  //----------------------------------------------------------------------------------------------------
  render() {
    const { classes }  = this.props;
  //const { loggedIn } = this.props;
  //const { logginIn } = this.props;
  //const { alert }    = this.props;

    return (
      <div className={classes.container}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={6} md={6}>

            <GridContainer justify="center">

                {/* ------------------------- */}
                {/* ----------[HONEYMOON]---- */}
                {/* ------------------------- */}
                <GridItem xs={12} sm={12} md={12} className={classes.GridItemTextField0}>
                    <TextField
                      fullWidth
                      autoComplete="off"
                      error={this.state.textField0_hasError}
                      className={classes.textField0}
                      id={this.autoCompleteText_Textfields()}
                      label={this.autoCompleteText_Textfields()}
                      value={this.state.textField0}
                      InputProps={{ fullWidth: true, onChange: event => this.change(event, "textField0"), type: "text" }}
                    />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                <div style={{ marginTop: 25 }}>
                  <div className={classes.labelHeader}>{this.NSInforString("RegisterLight1Login_title")}</div>
                  <div className={classes.logo}><img src={logo} alt="logo" /></div>
                </div>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <div className={classes.label1}>{this.NSInforString("RegisterLight1Login_lbl1")}</div>
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    disabled={this.state.loginEmail_disabled}
                    error={this.state.loginEmail_hasError}
                    className={classes.loginEmail}
                    id="loginEmail"
                    label={this.NSInforString("RegisterLight1Login_plh_user")}
                    value={this.state.loginEmail}
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "loginEmail"),
                      type: "email"
                    }}
                  />
                </GridItem>

                <GridItem xs={12} sm={12} md={12}>
                  <TextField
                    fullWidth
                    disabled={this.state.loginPassword_disabled}
                    onKeyPress={this.handleSubmit_with_enter}
                    error={this.state.loginPassword_hasError}
                    className={classes.loginPassword}
                    id="loginPassword_RegisterLight1Login"
                    label={this.NSInforString("RegisterLight1Login_plh_pass")}
                    defaultValue=""
                    InputProps={{
                      fullWidth: true,
                      onChange: event => this.change(event, "loginPassword"),
                      type: this.get_PasswordType1(),
                      endAdornment:
                        <InputAdornment position="end">
                          <IconButton onClick={this.handlePopoverOpen_passwordType1}  style={{padding:0}}> {this.get_PasswordType1()==="text" ? <VisibilityOff /> : <Visibility />}</IconButton>
                        </InputAdornment>
                    }}
                  />
                </GridItem>
                {/* ------------------------- */}
                {/* ----------[SPINNERS]----- */}
                {/* ------------------------- */}
                {this.state.viewPleaseWait_hidden === true ? ( "" ) : (
                  <GridContainer justify="center">
                    <GridItem xs={3} sm={3} md={3}></GridItem>
                    <GridItem xs={6} sm={6} md={6}>
                      <div className={classes.pleaseWait}><CircularProgress/><span>&nbsp;{this.NSInforString("please_wait")}</span></div>
                    </GridItem>
                    <GridItem xs={3} sm={3} md={3}></GridItem>
                  </GridContainer>
                )}
                {/* ------------------------- */}
                {/* ----------[BUTTONS]------ */}
                {/* ------------------------- */}
                <GridItem xs={10} sm={10} md={10}>
                  <div className={classes.textCenter}>
                    {/* <ReCAPTCHA
                      ref={ ref => this.recaptchaRef = ref }
                      locale={localStorage.getItem("lang")}
                      sitekey={api.captchKey}
                      onResolved={ this.handleSubmit } /> */}
                    <CustomButton
                      disabled={this.handleSubmit_isDisabled()}
                      className={classes.yellowButton}
                      color="rose"
                      onClick={this.handleSubmit}
                      type="submit">
                      {this.NSInforString("HomePage_btn_login")}
                    </CustomButton>
                  </div>
                </GridItem>

                <div className={classes.labelHeader}>&nbsp;</div>
                <div className={classes.labelHeader}>&nbsp;</div>

                <GridContainer justify="center">
                  <GridItem xs={6} sm={6} md={4} style={{justifyContent:"center", display:"flex"}}>
                    <NavLink
                      to={wu_Utilities.getNavigationURLs("ForgotPass1")}
                      activeStyle={{ color:'teal'}}
                      justify="center">
                      {this.NSInforString("HomePage_btn_forgotAccount")}
                    </NavLink>
                  </GridItem>
                </GridContainer>

                <div className={classes.labelHeader}>&nbsp;</div>
                <div className={classes.labelHeader}>&nbsp;</div>

              </GridContainer>

          </GridItem>
        </GridContainer>
        {/* ------------------------- */}
        {/* ----------[SNACKBAR]----- */}
        {/* ------------------------- */}
        <Snackbar open={this.state.Snackbar_textField_open} autoHideDuration={api.snackBarDurationMS} onClose={this.Snackbar_textField_handleClose}>
          <Alert onClose={this.Snackbar_textField_handleClose} severity="error">{this.state.Snackbar_textField_msg}</Alert>
        </Snackbar>
        {/* ------------------------- */}
        {/* ----------[POPUP]-------- */}
        {/* ------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog_handleClose}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">{this.state.dialog_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[POPUP RESEND CONFIRMATION EMAIL]------- */}
        {/* -------------------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog2_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog2_handleClose}
            aria-labelledby="alert-dialog2-slide-title"
            aria-describedby="alert-dialog2-slide-description"
          >
            <DialogTitle id="alert-dialog2-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog2-slide-description">{this.state.dialog2_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog2_handleResendEmail}>{this.NSInforString("alert_RESEND_CONFIRMATION_SMS")}</Button>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog_handleClose}>{this.NSInforString("alert_CANCEL")}</Button>
            </DialogActions>
          </Dialog>
        </div>
        {/* -------------------------------------------------- */}
        {/* ----------[POPUP GOTO SETTINGS]------------------- */}
        {/* -------------------------------------------------- */}
        <div>
          <Dialog
            open={this.state.dialog3_isOpen}
            TransitionComponent={Transition}
            keepMounted
            onClose={this.dialog3_handleClose}
            aria-labelledby="alert-dialog3-slide-title"
            aria-describedby="alert-dialog3-slide-description"
          >
            <DialogTitle id="alert-dialog3-slide-title">{api.popup_tile}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog3-slide-description">{this.state.dialog3_msg}</DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button className={classes.popupOkButton} color="default" onClick={this.dialog3_gotoProfile}>{this.NSInforString("alert_GO_TO_PROFILE")}</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Drop Down Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  //...
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Button Listeners----------------------------------
  //----------------------------------------------------------------------------------------------------
  handleSubmit_isDisabled(){
    return false;
  }
  handleSubmit_with_enter(event){
    if (event.charCode === 13) { // enter key pressed
      event.preventDefault();
      this.handleSubmit(event);
      // do something here
    }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit_with_recaptcha(event) {
    let methName = filename+"handleSubmit_with_recaptcha ";
    if(api.print_logs){console.log(methName);}

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.loginEmail.trim()    === "") { this.setState({"loginEmail_hasError"    : true }); emptyFields = true; }
      if(this.state.loginPassword.trim() === "") { this.setState({"loginPassword_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("email",this.state.loginEmail)===false){
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.verifyLength(this.state.loginEmail,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("RegisterLight1Login_plh_user"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    if(this.verifyLength(this.state.loginPassword,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("RegisterLight1Login_plh_pass"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    let loginPassword_hasGreekChar = false;
    let loginPassword              = this.state.loginPassword;
    for(let i=0; loginPassword.length>0 && i<loginPassword.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(loginPassword[i])===true){ loginPassword_hasGreekChar=true; break; } }
    if(loginPassword_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      return;
    }
    //++++++++
    //Continue
    //++++++++
    event.preventDefault();
    if(this.handleSubmit_isDisabled()){ console.log(methName+"reset");  this.recaptchaRef.reset();   }
    else                              { console.log(methName+"execute");this.recaptchaRef.execute(); }
  }
  //----------------------------------------------------------------------------------------------------
  handleSubmit(event) {
    let methName = filename+"constructor ";
    if(api.print_logs){console.log(methName);}

    //[Lockers]
    if( this.isLockersActive() ){ return; }
    else                        { this.startLockers(); }

    let shouldResetCaptcha = api.isCaptchaEnabled;

    //+++++++++++++++++++++++
    //validate Only Emptyness
    //+++++++++++++++++++++++
    let validateOnlyEmptyness = true;
    if(validateOnlyEmptyness){
      let emptyFields = false;
      if(this.state.loginEmail.trim()    === "") { this.setState({"loginEmail_hasError"    : true }); emptyFields = true; }
      if(this.state.loginPassword.trim() === "") { this.setState({"loginPassword_hasError" : true }); emptyFields = true; }
      if(emptyFields===true){this.stopLockers();if(shouldResetCaptcha){this.recaptchaRef.reset();}return;}
    }
    //+++++++++++++
    //validate Data
    //+++++++++++++
    if(this.verifyGenericItem("email",this.state.loginEmail)===false){
      this.dialog_handleOpen(this.NSInforString("email_validation"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(this.verifyLength(this.state.loginEmail,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("RegisterLight1Login_plh_user"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    if(this.verifyLength(this.state.loginPassword,1)===false){
      this.dialog_handleOpen(this.NSInforString("emtpy_field")+" "+this.NSInforString("RegisterLight1Login_plh_pass"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    let loginPassword_hasGreekChar = false;
    let loginPassword              = this.state.loginPassword;
    for(let i=0; loginPassword.length>0 && i<loginPassword.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(loginPassword[i])===true){ loginPassword_hasGreekChar=true; break; } }
    if(loginPassword_hasGreekChar===true){
      this.dialog_handleOpen(this.NSInforString("common.field.latin_no_greek"));
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //++++++++++++++++++++
    //validate [HONEYMOON]
    //++++++++++++++++++++
    if(this.state.textField0.trim()!==""){
      //this.setState({"textField1_hasError" : true });
      if(api.show_error_generic_input){this.dialog_handleOpen(this.NSInforString("error_generic_input"));}
      if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopLockers(); return;
    }
    //++++++++
    //Continue
    //++++++++
    localStorage.setItem("HTTP_user",this.state.loginEmail);

    //event.preventDefault();
    this.startSpinners();
    setTimeout(function() { //Start the timer
      //--------
      //wu_login
      //--------
      wu_LoginLogoutService
      .wu_login({username:this.state.loginEmail,password:this.state.loginPassword})
      .then(res => {
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        Cookies.set('isLoggedInAtWebApp', 'true', { expires:1, path:'' });
        wu_Utilities.registration_telephone_set("");
        wu_Utilities.update_uilatstats();
        //-------------------
        //wu_validatecustomer
        //-------------------
        wu_ProfileService
        .wu_validatecustomer({})
        .then(res => {
          //this.stopLockers();this.stopSpinners();
          localStorage.setItem("parserObject_validatecustomer",JSON.stringify(res.customer));
          this.stopLockers();this.stopSpinners();

          localStorage.setItem("LoginPage_flow",          "false");
          localStorage.setItem("RegisterLight1Login_flow","true");
          try { localStorage.setItem("newRegistrationFlow","newCustomer"); } catch(err){;}
          history.push(wu_Utilities.getNavigationURLs("RegisterLight2"));
          return;
        })
        .catch(err => { //wu_validatecustomer
          if(shouldResetCaptcha){this.recaptchaRef.reset();}
          this.stopLockers();this.stopSpinners();
          console.log(methName+"err="+JSON.stringify(err));
          if(err && err.returnCode && err.returnCode!==0){ if(err.returnCode===100){wu_Utilities.LogoutUserFromApp(filename);/*history.push(wu_Utilities.getNavigationURLs("LoginPage"));*/} this.dialog_handleOpen(err.returnText); }
          else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
        });
      })
      .catch(err => { //wu_login
        if(shouldResetCaptcha){this.recaptchaRef.reset();}
        this.stopLockers();this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){
          //nailed for testing:START---inactive
          //err.returnCode=4;
          //nailed for testing:END
          if(err.returnCode===4 ){ wu_Utilities.registration_telephone_set(err.data.phone); this.dialog2_handleOpen(err.returnText); }
          else                   { this.dialog_handleOpen(err.returnText);  }
        }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    }.bind(this), 500);
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------TextField Listeners-------------------------------
  //----------------------------------------------------------------------------------------------------
  change(event, stateVar) {
    let eventTMP = event.target.value+"";
    //if(api.print_logs){console.log(stateVar+" "+eventTMP);}

    if(api.allow_hp_to_be_edited===true && stateVar==="textField0"){ //[HONEYMOON]
      this.setState({"textField0":eventTMP.trim(),});
    }
    else if(stateVar==="loginEmail"){
      eventTMP = localStorage.getItem("HTTP_user") ? localStorage.getItem("HTTP_user") : eventTMP;
      this.setState({
        "loginEmail"          : eventTMP,
        "loginEmail_hasError" : (eventTMP.trim() === "") ? true : false,
      });
    }
    else if(stateVar==="loginPassword"){
      this.setState({
        "loginPassword"          : eventTMP,
        "loginPassword_hasError" : (eventTMP.trim() === "") ? true : false,
      });
      for(let i=0; eventTMP.length>0 && i<eventTMP.length; ++i){ if(/^[\u0391-\u03C9]*$/.test(eventTMP[i])===true){ this.Snackbar_textField_handleOpen(this.NSInforString("common.field.latin_no_greek")); this.setState({"loginPassword_hasError":true}); return; } }
    }
    else{
      this.setState({ [stateVar] : eventTMP });
    }
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Utilities-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  NSInforString = aKey => {
    if(localStorage.getItem("lang")==="en"){ return this.texts_en[aKey] ? this.texts_en[aKey] : ""; }
    else                                   { return this.texts_gr[aKey] ? this.texts_gr[aKey] : ""; }
  };
  //----------------------------------------------------------------------------------------------------
  verifyLength(value, length) {
    if (value && value.length >= length) { return true; }
    return false;
  }
  //----------------------------------------------------------------------------------------------------
  verifyGenericItem(key,val) {
    if(key==="email"){ return wu_Utilities.wu_verifyEmail(val); }

    return false;
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog_handleOpen(dialog_msg){
    this.setState({ "dialog_isOpen" : true });
    this.setState({ "dialog_msg"    : dialog_msg });
  }
  dialog_handleClose(){
    this.setState({ "dialog_isOpen": false });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups2--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog2_handleOpen(dialog2_msg){
    this.setState({ "dialog2_isOpen" : true });
    this.setState({ "dialog2_msg"    : dialog2_msg });
  }
  dialog2_handleClose(){
    this.setState({ "dialog2_isOpen": false });
  }
  dialog2_handleResendEmail(){
    let methName = filename+"dialog2_handleResendEmail ";
    if(api.print_logs){console.log(methName);}

    this.setState({ "dialog2_isOpen": false });

    let parserObject_checkAppVersion_req = {};
    parserObject_checkAppVersion_req["platform"]   = api.platform;
    parserObject_checkAppVersion_req["appVersion"] = api.appVersion;

    var parserObject_omtRegistrationResendOTP_req = {};
    parserObject_omtRegistrationResendOTP_req["email"]           = new Buffer(this.state.loginEmail.trim()).toString('base64');
    parserObject_omtRegistrationResendOTP_req["telephone"]       = wu_Utilities.registration_telephone_get();
    parserObject_omtRegistrationResendOTP_req["isMobile"]        = "1";
    parserObject_omtRegistrationResendOTP_req["recaptchaVerify"] = "";
    //---------------
    //checkAppVersion
    //---------------
    wu_AppVersion
    .wu_checkAppVersion(parserObject_checkAppVersion_req)
    .then(res => {
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      //this.stopSpinners();
      parserObject_omtRegistrationResendOTP_req["val1"] = res.val1;

      //---------------------------
      //wu_omtRegistrationResendOTP
      //---------------------------
      wu_RegisterLightService
      .wu_omtRegistrationResendOTP(parserObject_omtRegistrationResendOTP_req)
      .then(res => {
        this.stopSpinners();

        localStorage.setItem("parserObject_omtRegistrationResendOTP_req", JSON.stringify(parserObject_omtRegistrationResendOTP_req));
        //+++++++++++++++++
        //RegisterLight1OTP
        //+++++++++++++++++
        history.push(wu_Utilities.getNavigationURLs("RegisterLight1OTP"));
      })
      .catch(err => {
        this.stopSpinners();
        console.log(methName+"err="+JSON.stringify(err));
        if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText); }
        else                                           { this.dialog_handleOpen(this.NSInforString("networkerror")); }
      });
    })
    .catch(err => { //wu_checkAppVersion
      //if(shouldResetCaptcha){this.recaptchaRef.reset();}
      this.stopSpinners();
      console.log(methName+"err="+JSON.stringify(err));
      if(err && err.returnCode && err.returnCode!==0){ this.dialog_handleOpen(err.returnText,"NET"); }
      else                                           { this.dialog_handleOpen(this.NSInforString("networkerror"),"NET"); }
    });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Popups3--------------------------------------------
  //----------------------------------------------------------------------------------------------------
  dialog3_handleOpen(dialog3_msg){
    this.setState({ "dialog3_isOpen" : true });
    this.setState({ "dialog3_msg"    : dialog3_msg });
  }
  dialog3_handleClose(){
    this.setState({ "dialog3_isOpen": false });
  }
  dialog3_gotoProfile(){
    localStorage.setItem("LoginPage_flow",          "false");
    localStorage.setItem("RegisterLight1Login_flow","true");
    //++++++++++++++++
    //SettingsProfile1
    //++++++++++++++++
    history.push(wu_Utilities.getNavigationURLs("SettingsProfile1"));
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[SNACKBAR]----------------------------------------
  //----------------------------------------------------------------------------------------------------
  Snackbar_textField_handleOpen(msg){
    this.setState({
      "Snackbar_textField_open" : true,
      "Snackbar_textField_msg"  : msg,
    });
  }
  Snackbar_textField_handleClose(){
    this.setState({ "Snackbar_textField_open" : false });
  }
  //----------------------------------------------------------------------------------------------------
  get_PasswordType1(){
    return this.state.passwordType1;
  }
  handlePopoverOpen_passwordType1(){
    if(this.state.passwordType1==="password"){this.setState({ "passwordType1" : "text", });}
    if(this.state.passwordType1==="text")    {this.setState({ "passwordType1" : "password", });}
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Spinners------------------------------------------
  //----------------------------------------------------------------------------------------------------
  startSpinners(){
    this.setState({ "viewPleaseWait_hidden" : false });
  }
  //----------------------------------------------------------------------------------------------------
  stopSpinners(){
    this.setState({ "viewPleaseWait_hidden" : true });
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------[Lockers]-----------------------------------------
  //----------------------------------------------------------------------------------------------------
  isLockersActive(){
    if( RegisterLight1Login_continue_locked===true ){ return true;  }
    else                                            { return false; }
    //if( localStorage.getItem(filename.trim()+"_continue_locked")==="true" ){ /*console.log("isLockersActive===true");*/  return true;  }
    //else                                                                   { /*console.log("isLockersActive===false");*/ return false; }
  }
  //----------------------------------------------------------------------------------------------------
  startLockers(){
    RegisterLight1Login_continue_locked = true;
    //localStorage.setItem(filename.trim()+"_continue_locked","true");
  }
  //----------------------------------------------------------------------------------------------------
  stopLockers(){
    RegisterLight1Login_continue_locked = false;
    //localStorage.setItem(filename.trim()+"_continue_locked","false");
  }
  //----------------------------------------------------------------------------------------------------
  //--------------------------------------------------Autocomplete--------------------------------------
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_autoCompleteDropDown(){
    return filename+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
  autoCompleteText_Textfields(){
    //return filename+Math.random().toString().replace(/0\./g,"");
    //return filename.replace(/ /g,"")+Math.random().toString().replace(/0\./g,"");
    return Math.random().toString().replace(/0\./g,"")+"LP2"+Math.random().toString().replace(/0\./g,"");
  }
  //----------------------------------------------------------------------------------------------------
}
RegisterLight1Login.propTypes = {
  classes: PropTypes.object.isRequired
};
function mapStateToProps(state) {
  const { dispatch } = state;
//const { loggedIn } = state.authentication;
//const { logginIn } = state.authentication;
//const { alert }    = state;
  return {
    dispatch,
  //loggedIn,
  //logginIn,
  //alert,
  };
}
export default connect(mapStateToProps)(
  withStyles(RegisterLight1LoginStyle)(RegisterLight1Login)
);
